import 'onsenui/css/onsenui.css';
import './onsen-css-components.css';
import './assets/css/dark-onsen-css-components.css';
import './assets/css/ehoff.css';

// ON BUILD
//import './assets/css/{process.env.VUE_APP_VARIANT}.css';

import Vue from 'vue';
import Vuex from 'vuex';

import AppSplitter from "./AppSplitter";
import StandardToolbar from "./common/StandardToolbar";
import './registerServiceWorker';
import router from './router';
//import store from './store';
import storeLike from './store/index';
import VueOnsen from 'vue-onsenui'; // This imports 'onsenui', so no need to import it separately


import VueGoogleMap from 'vuejs-google-maps';

//import * as OnsenComponents from './views/ComponentCatalogue/onsen-components'; // For ESM

// Webpack CSS import
//import 'onsenui/css/onsen-css-components.css';
//import storeLike from "../../vue-onsenui-kitchensink/src/store";

Vue.use(VueOnsen);
Vue.use(Vuex);
Vue.use(VueGoogleMap,{
  load: {
    apiKey: process.env.VUE_APP_GOOGLE_APIKEY,
  }
});
//Vue.use(OnsenComponents);

Vue.config.productionTip = false;

Vue.component('qf-toolbar', StandardToolbar);

new Vue({
  router,
  store: new Vuex.Store(storeLike),
  beforeCreate() {
    Vue.prototype.md = true;
    this.$ons.platform.select(`android`);
    //Vue.prototype.md = this.$ons.platform.isAndroid();
  },
  render: h => h(AppSplitter)
}).$mount('#app');
